module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_wavy-line-navy-7d40e599f282ada6935526b1bf74467f.svg";